export default class SecureRandomString {
    static generateAlphanumeric(length) {
        const characters = [];
        while (characters.length < length) {
            const character = new Uint8Array(1);
            window.crypto.getRandomValues(character);
            if (SecureRandomString.isAlphaNumericAsciiCode(character[0])) {
                characters.push(String.fromCharCode(character[0]));
            }
        }
        return characters.join('');
    }
    static isAlphaNumericAsciiCode(code) {
        return (code >= 48 && code <= 57) || (code >= 65 && code <= 90) || (code >= 97 && code <= 122);
    }
}
//# sourceMappingURL=SecureRandomString.js.map